export default class ChoicesWrapper {
    constructor(element, options) {
        this.element = element;
        // workaround https://github.com/jshjohnson/Choices/issues/457
        const isDisabled = this.element.disabled;
        if (isDisabled) {
            this.element.disabled = false;
        }

        this.choicesInstance = new window.Choices(element, options);
        if (isDisabled) {
            this.element.disabled = true;
            this.choicesInstance.disable();
        }

        this.addListeners();
    }

    getChoicesInstance() {
        return this.choicesInstance;
    }

    addListeners() {
        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
                    this.updateChoicesDisabled(this.element.disabled);
                }
            });
        });
        this.observer.observe(this.element, { attributes: true });
    }

    updateChoicesDisabled(isDisabled) {
        if (isDisabled) {
            this.choicesInstance.disable();
        } else {
            this.choicesInstance.enable();
        }
    }

    destroy() {
        this.observer.disconnect();
    }
}
